import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChUpdateNutritionalCounsellingMutation as useChUpdateNutritionalCounsellingMutationType } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChUpdateNutritionalCounsellingMutation.graphql"

const mutation = graphql`
  mutation useChUpdateNutritionalCounsellingMutation($input: Ch_updateNutritionalPrescriptionInput!) {
    ch_updateNutritionalPrescription(input: $input) {
      ch_NutritionalPrescription {
        id
        ...chNutritionalCounsellingFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChUpdateNutritionalCounsellingMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChUpdateNutritionalCounsellingMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChUpdateNutritionalCounsellingMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdateNutritionalCounsellingMutation }
